<template>
    <div>

      <ComIndex :type="1" :orderType="1"/>

    </div>
</template>

<script>
import ComIndex from '../commonIndex'
export default {
  components: {
    ComIndex
  },
  data () {
    return {

    }
  },
  created () {

  },
  methods: {

  }

}
</script>
<style  scoped>

</style>
